function imageSlider() {

    $('.image-slider').each(function() {
        let $this = $(this),
            sliderWidth = $this.width(),
            sliderOffset = - (sliderWidth * 20) / 100,
			sliderID = $this.attr('id'),
            swiperArgs = {
                direction: 'horizontal',
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true
                },
                slidesPerView: 1,
                spaceBetween: 0,
                slidesOffsetBefore: 0,
                loop: true,
                initialSlide: 0,
                grabCursor: true,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    type: 'none'
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        slidesOffsetBefore: 0,
                        centeredSlides: true
                    }
                }
            };

        if ($this.is('[data-slider-type="image-text"]')) {
            swiperArgs.initialSlide = 1;
            swiperArgs.breakpoints[768]['slidesPerView'] = 'auto';
            swiperArgs.breakpoints[768]['loopAdditionalSlides'] = 2;
            swiperArgs.breakpoints[768]['slidesOffsetBefore'] = 125;
            swiperArgs.breakpoints[768]['spaceBetween'] = 30
            swiperArgs.breakpoints[768]['centeredSlides'] = false;
        }

        if ($this.is('[data-slider-type="image-data"]')) {
            swiperArgs.pagination['type'] = 'bullets';
            swiperArgs.breakpoints[768]['slidesPerView'] = 'auto';
            swiperArgs.breakpoints[768]['centeredSlides'] = false;
        }

        // console.log(swiperArgs);

        const swiper = new Swiper('#' + sliderID + ' .swiper', swiperArgs);
        // $(window).resize(function() {
        //     if ($this.is('[data-slider-type="image-text"]')) {
        //         sliderWidth = $this.width();
        //         sliderOffset = - (sliderWidth * 20) / 100;
        //         console.log(sliderOffset);
        //         swiper.params.breakpoints[768]['slidesOffsetBefore'] = sliderOffset;
        //         console.log(swiper.params.breakpoints[768]['slidesOffsetBefore']);
        //     }
        //     swiper.update();
        // });
    });

}